const qnaToastMsg = {
  // 성공
  AI_REPLY_GENERATE_SUCCESS: 'AI 답변이 생성되었습니다. 검토 후 사용해주세요.',

  // 클라이언트 에러
  AI_REPLY_NETWORK_ERROR: '네트워크 연결을 확인해주세요.',
  AI_REPLY_REQUEST_TIMEOUT: '요청 시간이 초과되었습니다. 다시 시도해주세요.',

  // 서버 응답 에러 (API에서 받은 에러 메시지를 그대로 표시하거나 기본 메시지 사용)
  AI_REPLY_SERVER_ERROR: 'AI 답변 생성에 실패했습니다. 잠시 후 다시 시도해주세요.',
} as const;

export default qnaToastMsg;
